<template>
  <div class="image-view">
    <div class="select">
      <div v-html="instructions"></div>
    </div>
    <table id="capture" class="MsoTableGrid" border="0" cellspacing="0" cellpadding="0" style="font-weight: normal;">
      <tr>
        <td colspan="4" :style="pronounBool ? 'padding-bottom: 2px;' : 'padding-bottom: 12px'">
          <div style="font-weight: normal;">
            <span style="

                font-size: 11pt;
                line-height: 10.8pt;
                white-space: nowrap;
                font-family: 'Aptos', 'Inter', Arial, sans-serif;
                font-weight: bold;
              ">{{ name }}
            </span>
          </div>
        </td>
      </tr>
      <tr v-if="pronounBool">
        <td colspan="4" style="
            padding-bottom: 12px;

            font-size: 9pt;
            line-height: 10.8pt;
            white-space: nowrap;
            font-family: 'Inter', Arial, sans-serif;
          ">
          <div style="font-weight: normal;">
            Pronouns: {{ pronoun }}
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="4" style="padding-bottom: 12px;">
          <div style="font-weight: normal;">
            <span style="
                font-weight: normal;
                font-size: 11pt;
                line-height: 10.8pt;
                white-space: nowrap;
                font-family: 'Aptos', 'Inter', Arial, sans-serif;
              " v-if="titleBool">{{ title }}</span>
            <br v-if="departmentBool" />
            <span style="
                font-weight: normal;
                font-size: 11pt;
                line-height: 10.8pt;
                white-space: nowrap;
                font-family: 'Aptos', 'Inter', Arial, sans-serif;
              " v-if="departmentBool">{{ department }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="4" style="padding-bottom: 12px; text-decoration: none !important">
          <div style="font-weight: normal;">
            <p style="
                margin: 0;
                padding: 0 0 2px 0;
                font-weight: normal;
                font-size: 11pt;
                line-height: 10.8pt;
                white-space: nowrap;
                font-family: 'Aptos', 'Inter', Arial, sans-serif;
              ">
              {{ phoneOffice }}: {{ phone }}
            </p>
            <p v-if="phone2" style="
                margin: 0;
                padding: 0 0 2px 0;
                font-weight: normal;
                font-size: 11pt;
                line-height: 10.8pt;
                white-space: nowrap;
                font-family: 'Aptos', 'Inter', Arial, sans-serif;
              ">
              {{ phone2Text }}: {{ phone2Number }}
            </p>
            <p v-if="phone3" style="
                margin: 0;
                padding: 0 0 2px 0;
                font-weight: normal;
                font-size: 11pt;
                line-height: 10.8pt;
                white-space: nowrap;
                font-family: 'Aptos', 'Inter', Arial, sans-serif;
              ">
              {{ phone3Text }}: {{ phone3Number }}
            </p>
            <p v-if="phone4" style="
                margin: 0;
                padding: 0 0 2px 0;
                font-weight: normal;
                font-size: 11pt;
                line-height: 10.8pt;
                white-space: nowrap;
                font-family: 'Aptos', 'Inter', Arial, sans-serif;
              ">
              {{ phone4Text }}: {{ phone4Number }}
            </p>
            <span class="email">
              <a v-bind:href="'mailto:' + email" style="
                  text-decoration: none !important;
                  color: #8E0DD1;
                  font-weight: normal;
                  font-size: 11pt;
                  line-height: 10.8pt;
                  white-space: nowrap;
                  font-family: 'Aptos', 'Inter', Arial, sans-serif;
                ">{{ email }}</a>
              <span v-if="emailNote" style="padding-bottom: 10px; color: red">
                New Email Address
              </span>
            </span>
          </div>
        </td>
      </tr>

      <tr v-if="address">
        <td colspan="4" style="
            padding-bottom: 12px;

            font-size: 11pt;
            line-height: 10.8pt;
            white-space: nowrap;
            font-family: 'Inter', Arial, sans-serif;
          ">
          <div style="font-weight: normal;">
            {{ addressLine1 }}
            <br />
            {{ addressLine2 }}
            <br />
            {{ addressLine3 }}
          </div>
        </td>
      </tr>

      <tr>
        <td valign="top" colspan="4" class="logo__cell" width="150" style="width: 150px; padding-bottom: 15px; padding-top: 15px">
          <a href="https://www.vantor.com" target="_blank">
            <img width="150" :src="logoPath"
              alt="Vantor" />
          </a>
        </td>
      </tr>

      <tr v-if="social" class="social">
        <td width="150" colspan="1" style="width: 150px">
          <table width="150" cellpadding="0" cellspacing="0" border="0" style="width: 150px;">
            <tr>
              <td width="30" style="width: 30px; text-align: center;">
                <a href="https://www.linkedin.com/company/vantortech" alt="LinkedIn" target="_blank">
                  <img width="18" height="18"
                    src="https://cdn.sanity.io/images/ava0h2e5/production/6a551f466c1263f92b0d2e35aa083a658f42df39-92x93.png" />
                </a>
              </td>
              <td width="30" style="width: 30px; text-align: center;">
                <a href="https://www.instagram.com/vantor_tech" alt="Instagram" target="_blank">
                  <img width="18" height="18"
                    src="https://cdn.sanity.io/images/ava0h2e5/production/9485f6f6721b71f103e45bfc91e8bf99ac908dbf-92x93.png" />
                </a>
              </td>
              <td width="30" style="width: 30px; text-align: center;">
                <a href="https://www.facebook.com/vantortech" alt="Facebook" target="_blank">
                  <img width="10" height="18"
                    src="https://cdn.sanity.io/images/ava0h2e5/production/6db384f17c678dcf92ee5036b3455e293e2c077e-52x91.png" />
                </a>
              </td>
              <td width="30" style="width: 30px; text-align: center;">
                <a href="https://www.youtube.com/@vantortech" alt="YouTube" target="_blank">
                  <img width="18" height="18"
                    src="https://cdn.sanity.io/images/ava0h2e5/production/c5384378ad43fc7194f067013a99f85318af91d5-93x65.png" />
                </a>
              </td>
              <td width="30" style="width: 30px; text-align: center;">
                <a href="https://x.com/vantortech" alt="X (Twitter)" target="_blank">
                  <img width="18" height="18"
                    src="https://cdn.sanity.io/images/ava0h2e5/production/5769cbdfea809b0e07c9960f55434cbdfbc85908-92x83.png" />
                </a>
              </td>
            </tr>
          </table>
        </td>
        <td>&#32;</td>
        <td>&#32;</td>
      </tr>
    </table>
    <div v-show="display" class="image-modal">
      <div id="image-container"></div>
      <div id="photo-instructions">
        <p>{{ pasteImageTxt }}</p>
      </div>
      <div class="close">
        <button class="language-btn" @click="display = !display">
          {{ closeImageBtnTxt }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageView",
  data: function () {
    return {
      display: false,
    };
  },
  props: {
    name: String,
    color: String,
    pronoun: String,
    pronounBool: Boolean,
    title: String,
    titleBool: Boolean,
    department: String,
    departmentBool: Boolean,
    phone: String,
    phone2: Boolean,
    phone2Number: String,
    phone2Text: String,
    phone3: Boolean,
    phone3Number: String,
    phone3Text: String,
    phone4: Boolean,
    phone4Number: String,
    phone4Text: String,
    social: Boolean,
    email: String,
    phoneOffice: String,
    instructions: String,
    closeImageBtnTxt: String,
    imageBtnTxt: String,
    pasteImageTxt: String,
    emailNote: Boolean,
    address: Boolean,
    addressLine1: String,
    addressLine2: String,
    addressLine3: String,
    language: String,
    logoPath: String,
  },
  methods: {
    saveCanvas() {
      let imageDiv = document.querySelector("#image-container");
      let canvas = document.querySelector("canvas");
      if (canvas) {
        imageDiv.removeChild(canvas);
      }
      window.html2canvas(document.querySelector("#capture"), {
        allowTaint: true,
        logging: true,
        y: 190,
      }).then((canvas) => {
        imageDiv.appendChild(canvas);
      });
    },

  },
};
</script>

<style>
a {
  text-decoration: none;
  font-family: 'Aptos', 'Inter', Arial, sans-serif;
}

table {
  font-family: 'Aptos', 'Inter', Arial, sans-serif;
  font-size: 11pt;
  table-layout: fixed;
  line-height: 10.8pt;
  white-space: nowrap;
}

p {
  margin: 0 !important;
  padding: 0 !important;

}

table,
td,
span,
a,
tr {
  white-space: nowrap;
}

.signature-area {
  padding: 40px;
}

.image-view {
  max-width: 800px;
}

.select {
  margin-bottom: 40px;
}

.image-modal {
  background-color: rgba(194, 190, 190, 0.95);
  height: 100%;
  left: 0;
  opacity: 1;
  position: fixed;
  top: 0;
  transform: scale(1);
  transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
  width: 100%;
  z-index: 10;
  overflow: scroll;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

h3 {
  margin-top: 5px;
  margin-bottom: 0;
}

.get-image-btn {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.green {
  color: #10ab82;
}

.blue {
  color: #3dc2da;
}

.royal {
  color: #0066ad;
}

.violet {
  color: #8e3e96;
}

.gold {
  color: #fbb01b;
}

.red {
  color: #ed2e5f;
}

canvas {
  padding: 10px;
}

#image-container {
  background-color: white;
}

@media (max-width: 600px) {
  .signature-area {
    padding: 20px;
  }
}

.social img {
  outline: none;
  border: none;
  position: relative;
  z-index: 1;
  object-fit: contain;
}

.social {
  position: relative;
  z-index: 1;
}

.email a {
  color: #8E0DD1 !important;
}

</style>
